<template>
    <div
        class="credit-score col-span-12 lg:col-span-6 overflow-hidden shadow rounded-lg relative"
    >
        <div v-if="loadingUserCreditScore">
            <DashboardCardSkeleton />
        </div>
        <div
            v-else-if="
                (!userScoreData.latest_score ||
                    userScoreData.latest_score === 0)
            "
            class="bg-white rounded-lg p-6 h-auto relative"
        >
            <start-tracking :onDashboard="onDashboard"></start-tracking>
        </div>
        <div
            v-else
            class="bg-white rounded-lg p-6 h-full relative"
        >
            <div class="flex justify-between items-center">
                <div class="flex items-center gap-2">
                    <icon icon="credit-score" class="text-slate-800" />
                    <span class="text-lg font-medium text-slate-800">
                        Credit Score
                    </span>
                </div>
                <a
                    href="/credit-score/"
                    class="flex items-center text-sm font-medium rounded text-slate-800 hover:text-slate-700 active:text-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-300 focus:ring-offset-0"
                >
                    View Details
                    <icon icon="arrow" />
                </a>
            </div>
            <div class="relative mx-auto max-w-md">
                <CreditscoreMeter />
                <div v-if="showOutdatedWarning" class="absolute left-1/2 transform -translate-x-1/2 translate-y-[-45px]">
                    <a
                        href="#"
                        class="h-9 px-4 py-2 rounded justify-start items-start gap-2 inline-flex text-sm font-medium text-slate-800 hover:text-slate-700 active:text-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-300 focus:ring-offset-0"
                        @click.prevent="openCreditScoreModal"
                        role="button"
                    >
                        <div class="w-5 h-5 justify-center items-center flex overflow-hidden">
                            <div class="w-5 h-5 relative flex-col justify-start items-start flex overflow-hidden">
                                <Icon icon="plus" class="text-black"/>
                            </div>
                        </div>
                        <div class="text-slate-800 text-sm font-medium font-['Inter'] leading-tight whitespace-nowrap">Add credit score</div>
                    </a>
                </div>
            </div>
        </div>
        <credit-score-modal @close="closeCreditScoreModal" />
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useCreditScoreStore } from '@/store/creditscore';
import CreditscoreMeter from '@/charts/creditscore/meter.vue';
import CreditScoreModal from '@/components/creditscore/modals/credit-score.vue';
import StartTracking from '@/components/creditscore/start-tracking.vue';
import Icon from '@/components/ui/icon/icon.vue';
import DashboardCardSkeleton from '@/components/dashboard/cards/dashboard-card-skeleton.vue';

export default {
    name: 'CreditScore',
    props: {
        onDashboard: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        CreditscoreMeter,
        CreditScoreModal,
        StartTracking,
        Icon,
        DashboardCardSkeleton,
    },
    computed: {
        ...mapState(useCreditScoreStore, [
            'loadingUserCreditScore',
            'userScoreData',
            'activeUser',
        ]),
    },
    data() {
        return {
            isOutdated: false,
        };
    },
    methods: {
        ...mapActions(useCreditScoreStore, [
            'openCreditScoreModal',
            'closeCreditScoreModal',
        ]),
        updateOutdatedStatus(status) {
            this.isOutdated = status;
        },
        showOutdatedWarning() {
            return this.userScoreData?.last_updated_days > 60;
        },
    },
    created() {},
    mounted() {},
};
</script>
